export default "__VITE_ASSET__CI$EMjBH__"